import request from '@/utils/request';

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
  });
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  });
}

export function verifyOtp(data) {
  return request({
    url: '/verify-otp',
    method: 'post',
    data,
  });
}

export function getUser() {
  return request({
    url: '/me',
    method: 'get',
  });
}

export function verifyPasswordToken(token) {
  return request({
    url: '/verify-password-token',
    method: 'post',
    data: { password_token: token },
  });
}

export function resetPassword(data) {
  return request({
    url: '/reset-password',
    method: 'post',
    data,
  });
}

export function updateUser(data) {
  return request({
    url: '/profile/save',
    method: 'post',
    data,
  });
}

export function resetUserPassword(data) {
  return request({
    url: '/profile/reset-password',
    method: 'post',
    data,
  });
}
